module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAmCAMAAABakYMNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRFy9nS2dva0ubd2+vkyNHM9PX06urq/Pz84uLj5/LrzuDY1unh7vXx0dHR////3u7pAnHF8QAAAQNJREFUeNqUldEagyAIRhFUKize/22nbrNVruS/6eYcSuwD2KyBEYhnQkTle4M/z0SEojX03yglpdZkIm2R0DdY8UsQif6GekbSI3QMhY+hUumQv4b0Pm+DlNKs7YDPRi5LI3AzSC3Jhk0ohk3I/YXZZGA2ElmNCQ2CuGIsllcUI1oMWrIRwNgsCN5mJNi88UZgc2g1TM2qRjQbydIsXBxso+0l8N6vazYGf1+BtaYYj+cgXKCUb4aTQbgm3+Df9p5hN8UYuEyGCI9wFbhN6qMhHbjW5322J7/D0IXDaRuwl0G4zXbnr9/RhZsxXWG+31FxFG5GeNPP8L6jYkw8vDlfAgwAyaliDVBOi74AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/PA.png
// module id = jFxE
// module chunks = 1